const agentSearchParamsKey = 'agentSearchParams';

export function getAgentSearchParams(): string | null {
  return window.sessionStorage.getItem(agentSearchParamsKey);
}

export function setAgentSearchParams(search: string): void {
  window.sessionStorage.setItem(agentSearchParamsKey, search);
}

export function clearAgentDetails(): void {
  window.sessionStorage.clear();
}
